import { useCountDown } from 'ahooks';
import { Form, Input } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { RevxButton } from 'components/RevxButton';
import RevxFlexLayout from 'components/RevxFlexLayout';
import { RevxSpin } from 'components/RevxSpin';
import { PartialAccount } from 'domains/accountDomain';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { RULE_EMAIL_TRIM, RULE_TEXT_LEN_255 } from 'utils/validators';
import './ForgotPassword.less';

export const ForgotPassword = (props: { setStep: Function }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const isSubmiting = useAppSelector(
    (state) => state.loading.effects.app.login
  );
  const history = useHistory();
  const [email, setEmail] = useState('');
  const [forgotten, setForgotten] = useState(false);

  const [targetDate, setTargetDate] = useState<number>();

  const [countdown] = useCountDown({
    targetDate,
    onEnd: () => {},
  });

  const [form] = Form.useForm();

  const [createdAccount, setCreatedAccount] = useState<string>('');

  const onForgot = async (forgotForm: PartialAccount) => {
    try {
      forgotForm.email = forgotForm.email?.trim();
      await dispatch.account.resetPassword({
        ...forgotForm,
      });
      setCreatedAccount(forgotForm.email || '');
      setForgotten(true);
      setTargetDate(Date.now() + 60000);
    } catch (e: any) {
      // if (!e.status) {
      //   error(e.message);
      // }
    }
  };

  const onCancel = () => {
    history.push('/');
  };

  const onValuesChange = (
    changedValues: { email?: string },
    allValues: { email?: string }
  ) => {
    setEmail(allValues.email || '');
  };

  return (
    <div className="forgotPassword-form">
      <h1 className="forgotPassword-form-title">
        {forgotten ? 'Forgot Password?' : t('login.forgotPassword.title')}
      </h1>
      <span hidden={forgotten} className="forgotPassword-form-subTitle">
        {t('login.forgotPassword.subTitleStep')}
      </span>
      <RevxSpin spinning={isSubmiting}>
        <div hidden={!forgotten}>
          <p className="forgotPassword-form-directions">
            {t('login.forgotPassword.sendEmailTip')}
          </p>
          <p className="forgotPassword-form-account">{createdAccount}</p>
          <p className="forgotPassword-form-directions">
            {t('login.forgotPassword.checkEmailTip')}
          </p>
          <p className="forgotPassword-form-tip">
            {t('login.forgotPassword.receiveEmailTip')}
          </p>
          <RevxFlexLayout>
            <p
              className="forgotPassword-form-tip"
              style={{ marginBottom: 0 }}
              hidden={countdown === 0}
            >
              {t('login.forgotPassword.reSendEmail')}
              <span style={{ paddingLeft: 6 }}>
                {`${Math.round(countdown / 1000)} s`}
              </span>
            </p>
            <a
              className="forgotPassword-form-link"
              hidden={countdown !== 0}
              onClick={() => {
                if (countdown !== 0) {
                  return false;
                }
                onForgot(form.getFieldsValue());
              }}
            >
              {t('login.forgotPassword.reSendEmail')}
            </a>
          </RevxFlexLayout>
        </div>
        <Form
          form={form}
          layout="vertical"
          onFinish={onForgot}
          onValuesChange={onValuesChange}
          hidden={forgotten}
        >
          <Form.Item className="form-item-username">
            <Form.Item
              rules={[
                {
                  required: true,
                  message: t('login.loginForm.usernameRequired'),
                },
                RULE_EMAIL_TRIM('email'),
                RULE_TEXT_LEN_255,
              ]}
              name="email"
              label={t('login.forgotPassword.emailAddress')}
              className={!email ? 'hide-label' : ''}
            >
              <Input
                autoFocus
                placeholder={t('login.forgotPassword.emailAddress')}
              />
            </Form.Item>
            {/* {username && (
              <CheckIcon
                className="check-icon"
                fill={themeData.primaryColor}
              />
            )} */}
          </Form.Item>
          <Form.Item className="form-item-button">
            <RevxButton
              size="large"
              htmlType="submit"
              type="primary"
              className="update-button"
            >
              {t('login.forgotPassword.submit')}
            </RevxButton>
            <RevxButton
              size="large"
              type="link"
              className="cancel-button"
              onClick={onCancel}
            >
              {t('login.forgotPassword.cancel')}
            </RevxButton>
          </Form.Item>
        </Form>
      </RevxSpin>
    </div>
  );
};
